<template>
  <!-- partial -->
  <div class="page-content">
    <div class="row">
      <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12">
        <h5 class="txt-dark">
          <back-button link="/form-managemnet/forms"></back-button>
          Add Form
        </h5>
      </div>
      <!-- Breadcrumb -->
      <div class="col-lg-4 col-sm-6 col-md-4 col-xs-12">
        <ol class="breadcrumb breadcrumb-line" style="float: right">
          <li class="breadcrumb-item">
            <router-link :to="`/`">Dashboard</router-link>
          </li>
          <li class="breadcrumb-item">System Setup</li>
          <li class="breadcrumb-item">
            <router-link :to="`/form-managemnet/forms`">Forms</router-link>
          </li>
          <li class="breadcrumb-item active" aria-current="page">Add</li>
        </ol>
      </div>
    </div>
    <!-- /Breadcrumb -->
    <!-- Form  -->
    <div class="row">
      <div class="col-md-10 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <div class="row mb-3">
              <label class="col-sm-2 col-form-label">Form Type</label>
              <div class="col-sm-10">
                <my-select
                  style="margin: 9px !important"
                  disableFormControl="true"
                  :selection.sync="form.form_type"
                  :suggestions="formTypes"
                  placeholder="Select Form Type"
                ></my-select>
              </div>
            </div>
            <div class="row mb-3">
              <label class="col-sm-2 col-form-label">Data Type</label>
              <div class="col-sm-10">
                <my-select
                  style="margin: 9px !important"
                  disableFormControl="true"
                  :selection.sync="form.data_type"
                  :suggestions="dataTypes"
                  placeholder="Select Data Type"
                ></my-select>
              </div>
            </div>
            <div class="row mb-3">
              <label class="col-sm-2 col-form-label">Category</label>
              <div class="col-sm-10">
                <my-select
                  style="margin: 9px !important"
                  disableFormControl="true"
                  :selection.sync="form.category_id"
                  :suggestions="categories"
                  placeholder="Select Category"
                ></my-select>
              </div>
            </div>

            <div class="row mb-3">
              <label class="col-sm-2 col-form-label">Title</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  v-model="form.title"
                  class="form-control"
                  autocomplete="off"
                  placeholder="Title"
                />
              </div>
            </div>

            <div class="row mb-3">
              <label class="col-sm-2 col-form-label">Code</label>
              <div class="col-sm-10">
                <input
                  type="number"
                  v-model="form.code"
                  class="form-control"
                  placeholder="Code"
                />
              </div>
            </div>

            <div class="row mb-3">
              <label class="col-sm-2 col-form-label">Date</label>
              <div class="col-sm-10">
                <my-datepicker
                  :date.sync="form.date"
                  placeholder="Enter Date"
                ></my-datepicker>
              </div>
            </div>
            <div class="row mb-3">
              <label class="col-sm-2 col-form-label">Edited By</label>
              <div class="col-sm-10">
                <input
                  type="number"
                  v-model="edited_by"
                  class="form-control"
                  :placeholder="`${company.name}`"
                  readonly
                />
              </div>
            </div>
            <div class="row mb-3">
              <label class="col-sm-2 col-form-label">Organization</label>
              <div class="col-sm-10">
                <my-select
                  style="margin: 9px !important"
                  disableFormControl="true"
                  :selection.sync="form.organization_id"
                  :suggestions="organizations"
                  placeholder="Select Organization"
                ></my-select>
              </div>
            </div>
            <div class="row mb-3">
              <label class="col-sm-2 col-form-label">Remarks</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  v-model="form.remarks"
                  class="form-control"
                  placeholder="Remarks"
                />
              </div>
            </div>

            <div class="row mb-3">
              <label class="col-sm-2 col-form-label">Filepath</label>
              <div class="col-sm-10">
                <input
                  type="file"
                  id="file"
                  name="file"
                  ref="file"
                  accept="application/ms-excel"
                />
              </div>
            </div>

            <div class="form-group mb-0">
              <submit-button
                :isLoading="isLoading"
                @submit="save"
                text="Save"
                style="float: right"
              ></submit-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- partial -->
</template>
<script type="text/javascript">
import axios from "axios";

export default {
  name: "FormCreate",
  data() {
    return {
      form: {
        form_type: "",
        data_type: "",
        category_id: "",
        organization_id: "",
      },
      countries: [],
      formTypes: [],
      dataTypes: [],
      categories: [],
      organizations: [],
      isLoading: false,
    };
  },
  mounted() {
    this.getMasters();
  },
  methods: {
    async getMasters() {
      let masters = await axios.get("forms/masters");
      masters = masters.data;
      masters.organizations.forEach((organization) => {
        this.organizations.push({
          id: organization.id,
          name: organization.name,
        });
      });
      masters.categories.forEach((category) => {
        this.categories.push({
          id: category.id,
          name: category.name,
        });
      });
    },
    async save() {
      try {
        this.isLoading = true;
        this.form.edited_by = this.company.name;
        let form = await axios.post("/forms", this.form);
        this.form = form.data.data;
        // await this.handleFileUpload();
        this.isLoading = false;
        this.$router.push("/form-management/forms");
      } catch (e) {
        this.isLoading = false;
      }
    },
    async handleFileUpload() {
      this.isLoading = true;
      let attachment = this.$refs.file?.files[0];
      const id = this.form.id;
      let formData = new FormData();
      formData.append("id", id);
      formData.append("logo", attachment);
      await axios
        .post("upload_form_logo", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .catch(function () {
          console.log("FAILURE!!");
        });
      if (this.career_request) {
        this.success = true;
        this.form = [];
      }
      this.isLoading = false;
    },
  },
};
</script>
